<template>
  <AutoComplete
    v-model="inputValue"
    :suggestions="options"
    :field="labelField"
    :disabled="disabled"
    @complete="onSearch($event)"
    @item-select="onSelect($event)"
    @clear="onClear()"
    :placeholder="placeholder"
    dropdown
  ></AutoComplete>
</template>

<script>
export default {
  name: 'AutocompleteApi',
  props: {
    value: Object,
    valueId: [String, Number],
    search: Function,
    labelField: {
      type: String,
      default: () => 'name',
    },
    idField: {
      type: String,
      default: () => 'id',
    },
    disabled: Boolean,
    placeholder: String,
  },
  data() {
    return {
      inputValue: null,
      options: [],
    };
  },
  mounted() {
    this.inputValue = this.value;
  },
  watch: {
    valueId(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.inputValue = this.value;
      }
    },
  },
  methods: {
    async onSearch(event) {
      const query = {
        [this.labelField]: event.query,
        orderField: this.labelField,
        order: 'asc',
      };
      const result = await this.search(query);
      this.options = result.results;
    },
    onSelect({ value }) {
      this.$emit('update:value', value);
      this.$emit('update:valueId', value[this.idField]);
      this.$emit('change', value);
    },
    onClear() {
      this.$emit('update:value', null);
      this.$emit('update:valueId', null);
    },
  },
};
</script>

<style>
</style>